import CookieHelpers from "../src/Components/Auth/CookieHelpers";

class AppConfig {
	constructor() {
		this.appBasePath = process.env.REACT_APP_APP_URL;
		this.userRoles = CookieHelpers.getCookie("userRoles");
		let TraffickingApiBasePath = "";
		try {
			TraffickingApiBasePath = `${process.env.REACT_APP_TRAFFICKING_URL.split(".publicismedia.com/")[0]}-api.publicismedia.com/`;
		} catch (e) {
			// noop
		}

		this.book = {
			ApiBasePath: process.env.REACT_APP_API_URL,
			TraffickingApiBasePath
		};
	}

	getBookApiBasePath = () => this.book;
	getAppBasePath = () => this.appBasePath;
	getUserRoles = () => this.userRoles;
}

export default new AppConfig();
